// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-G3":"G3_vanlife-roadtrips-G3__QIY63"};